import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const DeleteScheduledContentModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteScheduledContentModalContainer" */
      './DeleteScheduledContentModalContainer'
    ),
  loading: LoadingModal,
});
